import { useState } from "react";
import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import PaymentList from "../../sections/paymentList/paymentList";
import Footer from "../../sections/footer/footer";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";

const Payments = () => {
  const [message, setMessage] = useState("");

  return (
    <>
      <MobileMenu />
      <div className="page page--index page--cabinet">
        <Header />
        <main className="page__main">
          <PaymentList message={message} />
        </main>
        <Footer />
        <PopupForm setMessage={setMessage} />
        <CallbackForm />
      </div>
    </>
  );
};

export default Payments;
